import React, { useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { IconButton, Toolbar, Typography, TextField } from '@mui/material';

import { Search, Delete } from '@mui/icons-material/';
import { useNavigate } from 'react-router-dom';

import MyLayout from './layout/layout';
// import { routeName } from '../routes/paths';
import ConfirmDialog from '../components/ConfirmDialog';
import axios from '../AxiosInstance';
import useNotification from '../components/notification';

export default function Tags() {
  const [searchValue, setSearchValue] = useState('');
  const [tags, setTags] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedTag, setSelectedTag] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [filterTags, setFilterTags] = useState([]);

  const { sendNotification } = useNotification();
  const navigate = useNavigate();

  const columns = [
    { field: 'id', headerName: 'id' },
    {
      field: 'value',
      headerName: 'Tag name',
      width: 200,
    },
    {
      field: 'tagTypeId',
      headerName: 'ประเภท',
      // hide: true,
    },
    {
      field: 'homepage',
      disableColumnMenu: true,
      sortable: false,
      width: 150,
      headerAlign: 'center',
      headerName: 'Action',
      renderCell: (params) => {
        return (
          <React.Fragment>
            <IconButton
              color='error'
              onClick={() => {
                setOpenDialog(true);
                setSelectedTag(params.id);
              }}>
              <Delete />
            </IconButton>
          </React.Fragment>
        );
      },
      disableClickEventBubbling: true,
    },
  ];

  const fetchData = () => {
    axios
      .get(`/tags/`)
      .then((res) => {
        // console.log(res.data);
        let data = res.data.map((tag) => {
          return { ...tag, tagTypeName: tag.tagtype.name };
        });
        setTags(data);
        setFilterTags(data);
        // setFilterProducts(res.data);
        setLoading(false);
        // sendNotification({ msg: `Delete reportId : ${selectedReport.id}`, variant: 'success' });
      })
      .catch((err) => {
        console.error(err.response);
        setLoading(false);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };
  useEffect(() => {
    fetchData();
  }, []);

  const handleSearch = (e) => {
    // console.log(e.target.value);
    const keyword = e.target.value.toLocaleLowerCase();
    setSearchValue(keyword);
    // filter product name
    const filteredRows = tags.filter((tag) => {
      return tag.value.toLocaleLowerCase().indexOf(keyword) > -1;
    });
    setFilterTags(filteredRows);
    // console.log(filterProducts);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleDeleteSubmit = async () => {
    setOpenDialog(false);
    axios
      .delete(`/tags/${selectedTag}`)
      .then((res) => {
        // console.error(err.response);
        sendNotification({ msg: `Delete tag : ${selectedTag}`, variant: 'success' });
        fetchData();
      })
      .catch((err) => {
        console.error(err.response);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };
  return (
    <MyLayout>
      <Toolbar>
        <Typography variant='h6' noWrap component='div' sx={{ flexGrow: 1 }}>
          Tags
        </Typography>
        <TextField
          label='Search tag'
          value={searchValue}
          sx={{ mx: 2 }}
          size='small'
          InputProps={{
            endAdornment: <Search />,
          }}
          onChange={handleSearch}
        />
      </Toolbar>
      <DataGrid rows={filterTags} columns={columns} autoHeight loading={loading} disableSelectionOnClick />
      <ConfirmDialog
        title='Delete Tag?'
        content={`Are you sure to delete tag?`}
        submitText='Delete'
        open={openDialog}
        onClose={handleDialogClose}
        onSubmit={handleDeleteSubmit}
      />
    </MyLayout>
  );
}
